/**
 * Returns a retail price from a window object set inside template-product.liquid
 * If the variantId matches the window object variantId it will return the matching retail price.
 * Else it returns the first retail price in the array which will be the only one.
 *
 * TESTING: If you edit any of the logic in the below method you must check the PDP while on the trade store.
 * You will need to check the displayed price matches the variant retail price which is stored in a tag on the parent product.
 */

export default function getRetailPrice(variantId) {
    const retailPrice = window.Shopify.retailPrices.filter(
        price => price.variantId === variantId.toString()
    );

    if (retailPrice.length > 0) {
        return retailPrice[0].price;
    }
}
